import { IMenu } from '../shared/types/menu.type';
import { Role } from '../shared/consts/roles.enum';
import {
  ROUTE_ASSESSMENT_PACKAGE,
  ROUTE_EXCUSED_ABSENCES,
  ROUTE_GRADEBOOK,
  ROUTE_GROUP,
  ROUTE_HOME,
  ROUTE_STUDENT_GROUPS,
  ROUTE_SCHEDULE_EXCEPTIONS,
  ROUTE_USER,
  ROUTE_SEMESTERS,
  ROUTE_ANALYTICS,
} from '../shared/consts/routes.const';
import { Permits } from '../shared/types/auth.type';

export const MENU: IMenu[] = [
  {
    title: 'Расписание',
    url: ROUTE_HOME,
    icon: 'home',
  },
  {
    title: 'Пользователи',
    url: ROUTE_USER,
    icon: 'user',
    roles: [Role.ADMIN],
  },
  {
    title: 'Группы',
    url: ROUTE_GROUP,
    icon: 'team',
    roles: [Role.ADMIN, Role.MODERATOR],
  },
  {
    title: 'Электронный журнал',
    url: ROUTE_GRADEBOOK,
    icon: 'book',
    roles: [Role.MODERATOR],
    permits: [Permits.LECTURER_GIVE_CLASSES, Permits.STUDENT_GROUP_ANALYTICS],
  },
  {
    title: 'Комплекс контрольных мероприятий',
    url: ROUTE_ASSESSMENT_PACKAGE,
    icon: 'container',
    roles: [Role.MODERATOR],
    permits: [Permits.LECTURER_GIVE_CLASSES],
  },
  {
    title: 'Перенос занятий',
    url: ROUTE_SCHEDULE_EXCEPTIONS,
    icon: 'swap',
    roles: [Role.STUDENT_AFFAIRS_OFFICER],
  },
  {
    title: 'Уважительные причины',
    url: ROUTE_EXCUSED_ABSENCES,
    icon: 'exception',
    roles: [Role.STUDENT_AFFAIRS_OFFICER],
  },
  {
    title: 'Студенческие группы',
    url: ROUTE_STUDENT_GROUPS,
    icon: 'user-switch',
    permits: [Permits.STUDENT_GROUP_HEAD_STUDENT],
  },
  {
    title: 'Семестр',
    url: ROUTE_SEMESTERS,
    icon: 'schedule',
    roles: [Role.MODERATOR],
  },
  {
    title: 'Аналитика',
    url: ROUTE_ANALYTICS,
    icon: 'bar-chart',
    roles: [Role.ANALYST],
    permits: [Permits.LECTURER_GIVE_CLASSES, Permits.STUDENT_GROUP_ANALYTICS],
  },
];
